import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { Helmet } from 'react-helmet-async';

import type { Metadata } from '@/types/v2/metadata';
import { useUser } from '@/hooks/v2/use-user';

import { AccountSettingsHeader } from './account-settings-header';
import { SideNav } from './side-nav';

interface LayoutProps {
  children: React.ReactNode;
  metadata: Metadata;
}

export function Layout({ children, metadata }: LayoutProps): React.JSX.Element {
  const { account } = useUser();
  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.paper', minHeight: '100vh' }}>
        <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', px: { xs: 2, md: 4 }, py: 3 }}>
          <Container disableGutters maxWidth="xl">
            <AccountSettingsHeader
              account={account!}
              error={null}
              isLoading={false}
            />
          </Container>
        </Box>

        <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, md: 4 } }}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ position: 'relative' }}>
            <SideNav />
            <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{children}</Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
